import React, { useEffect } from 'react';
import { useFormik } from 'formik';

//MUI
import { Box, TextField, Grid, Modal, Divider, Typography, IconButton, Button } from '@mui/material';
import { Close } from '@mui/icons-material';
import { red } from '@mui/material/colors';

//COMPONENTS
import BasicSelect from '@components/Selects/BasicSelect';
import UploadSingleFile from '@components/Files/UploadSingleFile';

//VALIDATION & INTERFACE
import { Estructura } from '@data/schemas/EstructuraSchemas';
import { registrarInterface } from '@data/interfaces/EstructuraInterface';

const Register_form = (props) => {
  const {
    setModalOpen,
    modalOpen,
    params = {},
    title = 'Actualización de información',
    setData,
    catalogs = [],
    load = false,
    type,
  } = props;

  const formik = useFormik({
    initialValues: registrarInterface,
    validationSchema: Estructura(type),
    enableReinitialize: false,
    onSubmit: (values, actions) => {
      setData(values);
    },
  });

  const resetParams = () => {
    formik.resetForm();
    setModalOpen(false);
  };

  const handleEditModalClose = () => {
    setModalOpen(false);
  };

  const handleInputChange = (fieldName, fieldLabel) => (e) => {
    const { value } = e.target;

    const selectedMunicipio = catalogs?.municipios.find((municipio) => municipio.value === parseInt(value));
    const label = selectedMunicipio ? selectedMunicipio.label : '';

    formik.setValues((prevState) => ({
      ...prevState,
      [fieldName]: value,
      ...(fieldLabel ? { [fieldLabel]: label } : {}),
    }));
  };

  const handleNombre = handleInputChange('Nombre');
  const handleEmail = handleInputChange('Email');
  const handleMunicipio = handleInputChange('idMunicipio', 'Municipio');
  const handleCargo = handleInputChange('Cargo');

  const handleFiles = (e) => {
    formik.setValues((prev) => ({
      ...prev,
      files: [{ file: e }],
    }));
  };
  useEffect(() => {
    if (Object.keys(params).length > 0) {
      formik.setValues({
        type: type,
        id: params.id || '',
        idMunicipio: params.idMunicipio || '',
        Municipio: params.Municipio || '',
        Nombre: params.Nombre || '',
        Cargo: params.Cargo || null,
        Email: params.Email || null,
        imageName: params.imageName,
        files: [{ file: params.imagePath }],
        comparar: params.imagePath,
      });
    }
    //eslint-disable-next-line
  }, [params]);

  return (
    <Modal
      open={modalOpen}
      disableEscapeKeyDown
      aria-labelledby="modal-edit-title"
      aria-describedby="modal-edit-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 1100,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          borderRadius: 4,
          boxShadow: 24,
          p: 4,
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography id="modal-edit-title" variant="h6" component="h2">
            {title}
          </Typography>
          <IconButton onClick={handleEditModalClose}>
            <Close />
          </IconButton>
        </Box>
        <Divider />
        <Grid container spacing={1} sx={{ mt: 1 }}>
          {type !== 0 && (
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <BasicSelect
                error={Boolean(formik.touched.idMunicipio && formik.errors.idMunicipio)}
                errorMessage={formik.touched.idMunicipio ? formik.errors.idMunicipio : ''}
                name="Municipio"
                label="Municipio"
                options={catalogs?.municipios}
                value={formik.values.idMunicipio}
                onChange={handleMunicipio}
                size="small"
                sx={{ width: '100%', mt: 1 }}
                isLoading={load}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <TextField
              id="Nombre"
              variant="outlined"
              label="Nombre Completo"
              size="small"
              sx={{ width: '100%', mt: 1 }}
              value={formik.values.Nombre}
              onChange={handleNombre}
              error={Boolean(formik.touched.Nombre && formik.errors.Nombre)}
              helperText={formik.touched.Nombre ? formik.errors.Nombre : ''}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={4}>
            <TextField
              id="Email"
              variant="outlined"
              label="Correo Electronico"
              size="small"
              sx={{ width: '100%', mt: 1 }}
              value={formik.values.Email}
              onChange={handleEmail}
              error={Boolean(formik.touched.Email && formik.errors.Email)}
              helperText={formik.touched.Email ? formik.errors.Email : ''}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={4}>
            <TextField
              id="cargo"
              variant="outlined"
              label="Cargo / Puesto"
              size="small"
              sx={{ width: '100%', mt: 1 }}
              value={formik.values.Cargo}
              onChange={handleCargo}
              error={Boolean(formik.touched.Cargo && formik.errors.Cargo)}
              helperText={formik.touched.Cargo ? formik.errors.Cargo : ''}
            />
          </Grid>

          <Grid container spacing={2} mt={2} justifyContent="center">
            <Grid item xs={8}>
              <UploadSingleFile
                file={
                  formik.values.files && formik.values.files.length > 0
                    ? formik.values.files[0].file
                    : params.imagePath
                }
                setFile={handleFiles}
                accept="image/*"
              />
              {formik.touched.files &&
                formik.errors?.files &&
                Array.isArray(formik.errors.files) &&
                formik.errors.files[0]?.file && (
                  <Typography color="error">{formik.errors.files[0].file}</Typography>
                )}
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={2} justifyContent="center">
            <Grid item>
              <Button
                variant="contained"
                size="small"
                onClick={resetParams}
                style={{ backgroundColor: red[600], color: '#fff' }}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" color="primaryDark" size="small" onClick={formik.submitForm}>
                Guardar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default Register_form;
